export class LatestDisaster {
  constructor(disasterName, emergencyClassName, maxOilLevel) {
    this.disasterName = disasterName;
    this.emergencyClassName = emergencyClassName;
    this.maxOilLevel = maxOilLevel;
  }
  getDisasterName() {
    return this.disasterName;
  }
  getEmergencyClassName() {
    return this.emergencyClassName;
  }
  getMaxOilLevel() {
    return this.maxOilLevel;
  }
  static factory(disasterName, emergencyClassName, maxOilLevel = "") {
    return new LatestDisaster(disasterName, emergencyClassName, maxOilLevel);
  }
  static factoryDefault() {
    return new LatestDisaster("", "", "");
  }
}
